import { GetInsuranceMonitorExpandParameterInner } from "@wingspanhq/wingspan-api-sdk";

/**
 * `InsuranceMonitor.configuration` (the coverage requirements) and
 * `.coverage` (the linked policy) are only inlined when asked for — an
 * unexpanded read omits both keys. Every monitor read must therefore request
 * the same expansions, both so consumers can reach those fields and because
 * the v3 cache key is `[apiName, methodName, request]`: a read with a
 * different `expand` is a different cache entry.
 *
 * Both values are safe to request unconditionally — a monitor with no linked
 * coverage simply comes back without the key.
 *
 * Keep this the single source for the expansions: a `Set` serialises to `{}`
 * in the query-key hash, so two *different* expand sets would collide on one
 * cache entry.
 */
export const INSURANCE_MONITOR_EXPAND = new Set([
  GetInsuranceMonitorExpandParameterInner.CONFIGURATION,
  GetInsuranceMonitorExpandParameterInner.COVERAGE
]);
